/**
 * @module EnvStore
 * @description This module is written in a legacy style. Do not copy it. Instead, use repositories to manage state and persistence. Refer to ui/README.md for more.
 */
import { asyncReadable } from "@square/svelte-store";
const DEFAULT = {
    API_URI: undefined,
    BASE_URI: undefined,
    CONFIGURABLE_API_URI: undefined,
    SENTRY_DSN: undefined,
    OAUTH_DOMAIN: undefined,
    OAUTH_CLIENT_ID: undefined,
    OAUTH_AUDIENCE: undefined,
    STATSIG_CLIENT_KEY: undefined,
};
class MisconfigurationError extends Error {
}
export const envStore = asyncReadable(DEFAULT, async () => {
    let env = DEFAULT;
    try {
        const resp = await fetch("/~/env");
        const json = await resp.json();
        env = {
            API_URI: valueOrUndefined(json["API_URI"]),
            BASE_URI: valueOrUndefined(json["BASE_URI"]),
            CONFIGURABLE_API_URI: json["CONFIGURABLE_API_URI"],
            SENTRY_DSN: valueOrUndefined(json["SENTRY_DSN"]),
            OAUTH_DOMAIN: valueOrUndefined(json["OAUTH_DOMAIN"]),
            OAUTH_CLIENT_ID: valueOrUndefined(json["OAUTH_CLIENT_ID"]),
            OAUTH_AUDIENCE: valueOrUndefined(json["OAUTH_AUDIENCE"]),
            STATSIG_CLIENT_KEY: valueOrUndefined(json["STATSIG_CLIENT_KEY"]),
        };
    }
    catch (_e) {
        return env;
    }
    assertBaseURI(env["BASE_URI"]);
    assertAPIURI(env["API_URI"]);
    return env;
});
// Hosts disagree on whether the offending value makes it into `new URL`'s
// message, so name it ourselves — an operator reading this needs to know which
// URI was rejected.
function parseURI(value) {
    try {
        return new URL(value);
    }
    catch {
        throw new MisconfigurationError(`Invalid URL: ${value}`);
    }
}
function assertBaseURI(base) {
    if (base == null)
        return;
    const parsed = parseURI(base);
    if (parsed.origin !== window.location.origin) {
        throw new MisconfigurationError(`BASE_URI origin does not match current page. Expected ${window.location.origin} but got ${parsed.origin}`);
    }
}
function assertAPIURI(uri) {
    if (uri == null)
        return;
    parseURI(uri);
}
function valueOrUndefined(v) {
    return v === "" ? undefined : v;
}
